<template>
  <div>
    <Detail :enquiry-detail='enquiryDetail' v-bind="$attrs" v-on="$listeners" v-if="enquiryDetail.baisc.newTemplate===1"></Detail>
    <OldDetail :enquiry-detail='enquiryDetail' v-bind="$attrs" v-on="$listeners" v-else></OldDetail>
  </div>
</template>

<script>
import Detail from '../newEnquiry/Detail.vue'
import OldDetail from '../oldEnquiry/Detail.vue'
export default {
  name: "TicEnquiryDetail",
  components: {
    Detail,
    OldDetail
  },
  props: {
    enquiryDetail: {
      default: () => {},
      type: Object,
    },
  }
}
</script>

<style scoped>

</style>